export const RENDER_SERVICE_URL = import.meta.env.VITE_RENDER_SERVICE_URL || '/render'

export function absoluteRenderServiceUrl(): string {
  return RENDER_SERVICE_URL.startsWith('/')
    ? `${window.location.origin}${RENDER_SERVICE_URL}`
    : RENDER_SERVICE_URL
}

export interface CapturedSlide {
  slideId: string
  templateId: string
  position: number
  index: number
  base64: string
}

export async function captureMateriaPngs(materiaId: string): Promise<CapturedSlide[]> {
  const res = await fetch(`${RENDER_SERVICE_URL}/capture/materia`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ materiaId }),
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.error || `Falha ao capturar os PNGs (HTTP ${res.status}).`)
  }
  return res.json()
}

export async function removeBackgroundFromImage(source: Blob): Promise<Blob> {
  const res = await fetch(`${RENDER_SERVICE_URL}/images/remove-background`, {
    method: 'POST',
    headers: { 'Content-Type': source.type || 'application/octet-stream' },
    body: source,
  })

  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.error || `Falha ao remover o fundo (HTTP ${res.status}).`)
  }

  return res.blob()
}
